import organizations from "./organization";
import wallet from "./wallet";

export const apiOrganizations = organizations;
export const apiWallet = wallet;
